import { ErrorBoundary } from '@/pages/Company/procedures/free-time/requests/requests.error';

export default ErrorBoundary;
